import { render } from "./FriendsListItem.vue?vue&type=template&id=375901da&scoped=true"
import script from "./FriendsListItem.vue?vue&type=script&lang=js"
export * from "./FriendsListItem.vue?vue&type=script&lang=js"

import "./FriendsListItem.vue?vue&type=style&index=0&id=375901da&scoped=true&lang=css"

import exportComponent from "/Users/klausdresbach/Dropbox/IT-Projekte/Web-Entwicklung/niceplaces/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-375901da"]])

export default __exports__